var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c((((_vm.notification.key).replace(/[_]/g, '-')) + "-notif"),{tag:"component",attrs:{"data":_vm.notification.data}})}
var staticRenderFns = []

export { render, staticRenderFns }